import { UnitTransferRequestStatusEnumType } from '__generated__/graphql';

export default function unitTransferRequestStatusToReadable(
  status: UnitTransferRequestStatusEnumType
): {
  label: string;
  color: string;
} {
  switch (status) {
    case UnitTransferRequestStatusEnumType.Draft:
      return { label: 'Draft', color: 'gray' };
    case UnitTransferRequestStatusEnumType.Submitted:
      return { label: 'Submitted', color: 'sky' };
    case UnitTransferRequestStatusEnumType.PendingTransfereeAcknowledgement:
      return { label: 'Pending Transferee Acknowledgement', color: 'amber' };
    case UnitTransferRequestStatusEnumType.TransfereeDeclined:
      return { label: 'Transferee Declined', color: 'red' };
    case UnitTransferRequestStatusEnumType.UnderReview:
      return { label: 'Under Review', color: 'amber' };
    case UnitTransferRequestStatusEnumType.PendingEscrowException:
      return { label: 'Pending Escrow Exception', color: 'amber' };
    case UnitTransferRequestStatusEnumType.ConditionsIssued:
      return { label: 'Conditions Issued', color: 'indigo' };
    case UnitTransferRequestStatusEnumType.PendingDocuments:
      return { label: 'Pending Documents', color: 'amber' };
    case UnitTransferRequestStatusEnumType.DocumentsIncomplete:
      return { label: 'Documents Incomplete', color: 'red' };
    case UnitTransferRequestStatusEnumType.DocumentsUnderReview:
      return { label: 'Documents Under Review', color: 'amber' };
    case UnitTransferRequestStatusEnumType.DocumentsVerified:
      return { label: 'Documents Verified', color: 'indigo' };
    case UnitTransferRequestStatusEnumType.PendingSignatures:
      return { label: 'Pending Signatures', color: 'amber' };
    case UnitTransferRequestStatusEnumType.Executed:
      return { label: 'Executed', color: 'green' };
    case UnitTransferRequestStatusEnumType.ReadyForDis:
      return { label: 'Ready For DIS', color: 'lime' };
    case UnitTransferRequestStatusEnumType.Rejected:
      return { label: 'Rejected', color: 'red' };
    case UnitTransferRequestStatusEnumType.Withdrawn:
      return { label: 'Withdrawn', color: 'gray' };
    default:
      return { label: status, color: 'gray' };
  }
}
